export const DELETED_MESSAGE_MESSAGE: string = 'Message deleted';